<button
  (click)="onClick($event)"
  class="button-link"
  (click)="($event)"
  [ngClass]="{ pressed: buttonPressedState, black: color === Color.Black }"
>
  {{ text }}
</button>
